export default __webpack_public_path__ + "assets/images/6f9ef2ed487f4640a1972773ac34ce5b.jpg";